import React, { ReactElement, useMemo } from 'react'
import { Field, FieldRenderProps } from 'react-final-form'
import { Box, FormHelperText } from '@mui/material'
import { useTranslate } from 'src/i18n/useMessageSource'
import { CurrencyObject } from 'src/service/view-model/base/payment/Currencies'
import { CurrencyAutoComplete, CurrencyAutoCompleteProps } from 'src/ui-shared/form/control/CurrencyAutoComplete'

interface CurrencyAutoCompleteField extends CurrencyAutoCompleteProps {
  validate?: any
}

type ExposeCurrencyAutoCompleteFieldProps = Omit<CurrencyAutoCompleteField, 'onChange' | 'value'>

type AutoCompleteFieldValueType = CurrencyObject | undefined

type CustomCurrencyAutoCompleteProps = FieldRenderProps<AutoCompleteFieldValueType> &
  ExposeCurrencyAutoCompleteFieldProps

const CustomCurrencyAutoComplete = (props: CustomCurrencyAutoCompleteProps): ReactElement => {
  const {
    input: { name, value, onChange: onChangeFinalForm },
    meta,
    validate: _validate,
    ...rest
  } = props

  const autoCompleteProps = rest as ExposeCurrencyAutoCompleteFieldProps

  const { touched, error: errorObject } = meta

  const translate = useTranslate()

  const error = errorObject && translate(errorObject.errorKey, errorObject.params)

  const invalid = Boolean(touched && error)

  const onChangeMemo = useMemo<(optionValue: AutoCompleteFieldValueType) => void>(
    () =>
      (optionValue: AutoCompleteFieldValueType): void => {
        onChangeFinalForm(optionValue)
      },
    [onChangeFinalForm],
  )

  const finalAutoCompleteProps: CurrencyAutoCompleteProps = {
    ...autoCompleteProps,
    onChange: onChangeMemo,
    name: name,
    error: invalid,
    value,
  }

  return (
    <Box>
      <CurrencyAutoComplete {...finalAutoCompleteProps} />
      {invalid && <FormHelperText error>{error}</FormHelperText>}
    </Box>
  )
}

export const CurrencyAutoCompleteValidate = (props: ExposeCurrencyAutoCompleteFieldProps): ReactElement => (
  <Field component={CustomCurrencyAutoComplete} {...props} />
)
